<!-- @format -->
<template>
  <div id="customMenu">
    <div class="navBox">
      <el-scrollbar style="height: 100%">
        <div class="box-content">
          <el-menu
            router
            unique-opened
            :default-active="String(activeNav)"
            background-color="transparent"
          >
            <!-- 引入组件 -->
            <menu-tree :menuData="menuList"></menu-tree>
          </el-menu>
        </div>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import menuTree from "./menuTree.vue";
export default {
  name: "customMenu",
  components: {
    menuTree,
  },
  props: ["menuList"],
  data() {
    return {
      selectMenu: [],
    };
  },
  computed: {
    activeNav() {
      let paths = ["/404", "/login"];
      if (!paths.includes(this.$route.path)) {
        this.handleChange(this.$route.path);
      }
      // 获取当前激活的导航
      return this.$route.path;
    },
  },
  methods: {
    findMenuItemByPath(menuList, path) {
      for (const menuItem of menuList) {
        // 如果当前菜单项的路径匹配，直接返回
        if (menuItem.menuLink === path) {
          return menuItem;
        }
        // 如果有子菜单，递归查找
        if (menuItem.children && menuItem.children.length > 0) {
          const foundItem = this.findMenuItemByPath(menuItem.children, path);
          if (foundItem) {
            return foundItem;
          }
        }
      }

      return null; // 未找到
    },
    handleChange(val) {
      let selectMenu = [];
      // 提前查找本地存储的点击过的菜单
      selectMenu = JSON.parse(sessionStorage.getItem("selectMenu")) || [];
      // 首先判断本地是否存在数据
      if (selectMenu && selectMenu.length > 0) {
        // 判断本地数据是否已包含当前点击的路由
        let clickNode = selectMenu.find((res) => {
          return res.menuLink === val;
        });
        if (clickNode) {
          this.$bus.$emit("selectMenuItem", {
            node: clickNode,
            nodeList: selectMenu,
          });
        } else {
          // 没找到就存储
          selectMenu.push(this.findMenuItemByPath(this.menuList, val));
          sessionStorage.setItem("selectMenu", JSON.stringify(selectMenu));
          this.$bus.$emit("selectMenuItem", {
            node: this.findMenuItemByPath(this.menuList, val),
            nodeList: selectMenu,
          });
        }
      } else {
        // 没找到就存储
        selectMenu.push(this.findMenuItemByPath(this.menuList, val));
        sessionStorage.setItem("selectMenu", JSON.stringify(selectMenu));
        this.$bus.$emit("selectMenuItem", {
          node: this.findMenuItemByPath(this.menuList, val),
          nodeList: selectMenu,
        });
      }
    },
  },
};
</script>
<style lang="scss">
.el-scrollbar__wrap {
  overflow-x: hidden;
}
</style>
<style lang="scss" scoped>
#customMenu {
  box-sizing: border-box;
  overflow-y: auto;
  width: 100%;
  float: left;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  .navBox {
    box-sizing: border-box;
    width: 100%;
    //height: 100%;
    background-color: #ffffff;
    height: calc(100vh - 0.58rem);
    overflow-y: auto;
    padding-top: 0.1rem;
    .box-content {
      //padding: 0 0.15rem 0 0rem;
      box-sizing: border-box;
    }
    .menu-box {
      width: 100%;
      height: 0.5rem;
      margin-bottom: 0.1rem;
      box-sizing: border-box;
      cursor: pointer;
      display: flex;
      align-items: center;

      padding-left: 0.45rem;
      padding-top: 0.04rem;
      .menu-icon {
        img {
          width: 0.22rem;
          height: 0.22rem;
          position: relative;
          top: 0.01rem;
        }
      }
      .menu-text {
        font-size: 0.16rem;
        color: #ffffff;
        margin-left: 0.08rem;
        position: relative;
        .msg-num {
          position: absolute;
          top: -0.1rem;
          right: -0.35rem;
          border-radius: 0.08rem;
          padding: 0.02rem 0.06rem;
          background-color: red;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
